<div
	*ngIf="!isLoadingSearchResults; else skeletonLoader"
	class="disable-scrollbars"
	id="searchList"
>
	<p *ngIf="showChipsVertically" class="primary-text font-size-20" fxLayoutAlign="center center">
		Frequent Lanes
	</p>

	<mat-chip-list aria-label="Top Searches">
		<div
			class="full-width"
			fxLayoutAlign="{{ topSearches.length === TOP_SEARCHES_SIZE ? layoutAlign : 'start center' }}"
		>
			<mat-chip
				(click)="setQueryParams(search)"
				*ngFor="let search of topSearches"
				style="background-color: white; cursor: pointer"
			>
				<a class="primary-text" fxLayoutAlign="center center">
					{{ search.origin.city }}
					<mat-icon
						class="primary"
						matPrefix
						style="vertical-align: bottom; margin-bottom: -4px !important"
					>
						arrow_forward
					</mat-icon>
					{{ search.destination.city }} ({{ search.abbreviatedTrailerTypes }})
				</a>
			</mat-chip>
		</div>
	</mat-chip-list>
</div>

<ng-template #skeletonLoader>
	<div>
		<app-skeleton-loader [SHOW_CHIPS]="true"></app-skeleton-loader>
	</div>
</ng-template>
